// extracted by mini-css-extract-plugin
module.exports = {"titleAccordion":"Accordion_titleAccordion__1cFwI","mobileMenu":"Accordion_mobileMenu__3764k"};